/* eslint-disable react-hooks/exhaustive-deps */
//layout
import BaseLayout from "../Layout/BaseLayout";
// react-i18next
import { useTranslation } from "react-i18next";
//heroicon
import { Button, Divider, Spinner } from "@nextui-org/react";
import { useApi } from "../Context/ApiProvider";
import { useEffect, useRef, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { MdOutlineHomeWork } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { FiPhone } from "react-icons/fi";
import { Helmet } from "react-helmet";

export function ContactItem({ icon, topic, text }) {
  return (
    <div className=" transform transition duration-500 hover:scale-110 cursor-pointer hover:bg-primary-800 hover:text-white ">
      <div className=" px-4 py-5 ">
        <div className="flex justify-center">{icon}</div>

        <div className=" flex flex-col  items-center justify-between mt-5 gap-2 ">
          <span className=" text-xl  font-semibold font-YekanBakhMedium  whitespace-nowrap ">
            {topic} :
          </span>
          <span className=" break-all">{text}</span>
        </div>
      </div>
    </div>
  );
}

export default function Factory() {
  const firstNameRef = useRef();
  const lastNameRef = useRef();
  const emailRef = useRef();
  const telRef = useRef();
  const subjectRef = useRef();
  const messageRef = useRef();
  const [contacts, setContacts] = useState(null);
  const { t } = useTranslation();
  const api = useApi();
  const navigate = useNavigate();
  const [loadingPage, setLoadingPage] = useState(false);
  const [seoData, setSeoData] = useState({
    seo_title: "",
    search_description: "",
  });

  useEffect(() => {
    (async () => {
      setLoadingPage(true);
      const resContacts = await api.uget(`/api/contacts?`);
      if (resContacts.ok && resContacts.body) {
        const fetchedContact = resContacts.body;
        setContacts(fetchedContact);
        setSeoData({
          seo_title: resContacts.body.seo_title,
          search_description: resContacts.body.search_description,
        });
      }
      setLoadingPage(false);
    })();
  }, [api]);

  const handleSubmit = async () => {
    const body = {
      first_name: firstNameRef.current.value,
      last_name: lastNameRef.current.value,
      email: emailRef.current.value,
      tel: telRef.current.value,
      subject: subjectRef.current.value,
      message: messageRef.current.value,
    };

    const fields = [
      { ref: firstNameRef, name: "first_name" },
      { ref: lastNameRef, name: "last_name" },
      { ref: emailRef, name: "email" },
      { ref: telRef, name: "tel" },
      { ref: subjectRef, name: "subject" },
      { ref: messageRef, name: "message" },
    ];

    let allFilled = true;

    // Reset borders to default
    fields.forEach((field) => {
      field.ref.current.classList.remove("border-red-500");
    });

    // Check for empty fields and apply red border
    fields.forEach((field) => {
      if (!field.ref.current.value) {
        allFilled = false;
        field.ref.current.classList.add("border-red-500");
      }
    });

    if (!allFilled) {
      return toast.error(t("ّFailedInformation"));
    }

    // Proceed with submitting the form if all fields are filled
    const res = await api.upost("/api/contacts?", body);
    if (res.status === 201) {
      toast.success(t("SuccessInformation"));
      fields.forEach((field) => {
        field.ref.current.value = ""; // Clear input values
      });
    }
  };

  return (
    <BaseLayout>
      <Helmet>
        <title>{seoData.seo_title}</title>
        <meta name="description" content={seoData.search_description} />
      </Helmet>
      <Swiper
        dir="ltr"
        className="h-[25rem] xl:h-[35rem]  "
        loop={true}
        navigation={true}
        modules={[Navigation]}
      >
        <div className="text-white  lg:text-3xl absolute top-[60%]  left-[50%]  lg:left-[70%] transform -translate-x-1/2 -translate-y-1/2 z-10  flex flex-col gap-3 items-center">
          {t("factory")}
          <Divider className="  h-1 bg-red-600    " />
          <div
            className={`bg-white px-5 py-2 rounded-md   flex justify-center items-center w-full whitespace-nowrap ${
              localStorage.getItem("lng") === "fa"
                ? "rtl  flex-row-reverse "
                : localStorage.getItem("lng") === "en"
                ? "ltr"
                : ""
            }`}
          >
            <div
              className="text-sm text-gray-600 cursor-pointer "
              onClick={() => navigate("/")}
            >
              {t("menuHome")}
            </div>
            <span className="px-2  text-gray-800">/</span>
            <div>
              <span
                className=" text-sm text-gray-600 cursor-pointer"
                onClick={() => navigate("/contact")}
              >
                {t("menucontactUs")}
              </span>
            </div>
            <span className="px-2  text-gray-800">/</span>

            <div>
              <span className="text-[15px] font-bold text-black">
                {t("factory")}
              </span>
            </div>
          </div>
        </div>
        <SwiperSlide key={1}>
          <img
            src="/Assets/Images/factory.jpg"
            className="lg:w-[50%] h-full "
            alt="1"
            style={{
              WebkitMaskImage:
                "linear-gradient(to right, black 90%, transparent 100%)",
              maskImage:
                "linear-gradient(to right, black 90%, transparent 100%)",
            }}
          />
          <div className="lg:absolute lg:top-0 right-0 w-full lg:w-[80rem] h-full bg-gradient-to-l from-primary-800 to-transparent opacity-100" />
        </SwiperSlide>
      </Swiper>
      <div>
        <Toaster />
      </div>
      {!contacts || loadingPage ? (
        <Spinner size="lg" className="flex justify-center mt-16 mb-16" />
      ) : (
        <div className="w-[85%] m-auto">
          <div className="lg:flex grid lg:grid-cols-2 items-center mt-10 mb-20 gap-5 xl:gap-10 justify-center ">
            <div className="2xl:w-1/3 w-full 2xl:!pt-2.5  gap-10 bg-white rounded-lg p-2 ">
              <ContactItem
                icon={<FiPhone size={50} color="#3EA3DB" />}
                topic={t("fmcall")}
                text={contacts.tel3}
              />
            </div>

            <div className="2xl:w-1/2  2xl:!py-2 bg-white rounded-lg w-full ">
              <ContactItem
                icon={<MdOutlineHomeWork size={50} color="#3EA3DB" />}
                topic={t("fmAddress")}
                text={contacts.address2}
              />
            </div>
          </div>
          <section className="text-gray-600 body-font relative top-10 ">
            <div className="  grid grid-cols-1  ">
              <div className=" bg-gray-300 w-full h-[600px]   rounded-2xl shadow-lg   p-10 flex relative bottom-10">
                <iframe
                  width="100%"
                  height="100%"
                  className="absolute inset-0"
                  title="map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d51372.45213405747!2d59.694403771178976!3d36.41455984677681!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f6c871141fe4efb%3A0x17f689487fa572d6!2z2LTYsdqp2Kog2YHbjNiv2KfYsSDYtNuM2YXbjCDZvtin2LHYsw!5e0!3m2!1sfa!2s!4v1732961923583!5m2!1sfa!2s"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>

              <div className="  bg-white p-2  rounded-xl flex flex-col w-full h-[40rem] lg:h-[37rem]   ">
                <div className="lg:w-[50%] w-full md:w-[80%] m-auto text-center relative -top-10 ">
                  <h2 className="text-gray-900 text-2xl mb-5  font-medium title-font">
                    {t("contactFormTitle")}
                  </h2>

                  <div className="lg:flex gap-5  mb-4">
                    <input
                      type="text"
                      ref={firstNameRef}
                      id="name"
                      name="name"
                      placeholder={t("fmname")}
                      className="lg:w-4/5 w-full bg-white rounded border border-gray-300 focus:border-primary focus:ring-2  text-base outline-none text-gray-700 mb-4 lg:mb-0 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                    />
                    <input
                      type="text"
                      ref={lastNameRef}
                      id="name"
                      placeholder={t("fmlastName")}
                      className="lg:w-4/5 w-full bg-white rounded border border-gray-300 focus:border-primary focus:ring-2 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                    />
                  </div>

                  <div className="relative mb-4">
                    <input
                      type="email"
                      ref={emailRef}
                      id="email"
                      name="email"
                      placeholder={t("fmEmail")}
                      className="w-full bg-white rounded border border-gray-300 focus:border-primary  focus:ring-2  text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                    />
                  </div>

                  <div className="relative mb-4">
                    <input
                      type="text"
                      ref={telRef}
                      id="text"
                      placeholder={t("fmphone")}
                      className="w-full bg-white rounded border border-gray-300 focus:border-primary focus:ring-2  text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                    />
                  </div>

                  <div className="relative mb-4">
                    <input
                      type="text"
                      ref={subjectRef}
                      id="text"
                      placeholder={t("fmsubject")}
                      className="w-full bg-white rounded border border-gray-300 focus:border-primary focus:ring-2  text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                    />
                  </div>

                  <div className="relative mb-2">
                    <textarea
                      id="message"
                      ref={messageRef}
                      name="message"
                      placeholder={t("fmmessage")}
                      className="w-full bg-white rounded border border-gray-300 focus:border-primary focus:ring-2  h-32 text-base outline-none text-gray-700 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"
                    ></textarea>
                  </div>

                  <Button
                    onClick={handleSubmit}
                    className="text-white bg-primary w-full   px-6 focus:outline-none  rounded text-lg"
                    variant="bordered"
                  >
                    {t("Send")}
                  </Button>
                </div>
              </div>
            </div>
          </section>
        </div>
      )}
    </BaseLayout>
  );
}
